import { BodyText } from '@make-software/cspr-design';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';

export const DetailsLocation = ({
  location,
}: {
  location: { country?: string; name?: string };
}) => {
  return (
    <>
      <BodyText size={3}>
        <ReactCountryFlag
          countryCode={location.country}
          svg
          style={{
            marginRight: 8,
          }}
        />
        <span>{`${location.name}, ${location.country}`}</span>
      </BodyText>
    </>
  );
};
